export default __webpack_public_path__ + "static/media/terraza.a60324b1.svg";